<section class="focus">
  <div class="flex-container">
    <div class="flex-row flex-justify-center">
      <div class="flex-col-12">
        <div class="survey">
          <app-account-greenness-survey
            [webApp]="true"
            [appLocation]="appLocation"
            translationKey="onboardingSurvey"
            showSurvey="greenness"
            (surveySubmit)="onSurveySubmit($event)"
          ></app-account-greenness-survey>
          <app-swiss-made-footer></app-swiss-made-footer>
        </div>
      </div>
    </div>
  </div>
</section>
